module.exports = __webpack_public_path__ + "img/9.5acb7cd8.jpg";